// extracted by mini-css-extract-plugin
export var typingIndicator = "_rz-0";